import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import Button from "../../../ui-components/Button";
import Modal from "../../../ui-components/Modal";
import { ApproveQuotationModalProps } from "./types";
import Checkbox from "@ui-components/Checkbox";


export const ApproveQuotationModal = ({
  onConfirm,
  onDismiss,
  loading,
}: ApproveQuotationModalProps) => {

  // state
  const [checked, setChecked] = useState<boolean>(false);

  return (
    // @ts-ignore
    <Modal onExit={onDismiss}>
      <div className="flex flex-col gap-8">
        <h1 className="text-2xl font-extrabold">
          <FormattedMessage id="approve_quotation" defaultMessage="Approva preventivo"/>
        </h1>
        <div className="flex flex-row gap-4 items-start">
          <Checkbox
            id="approval-confirm"
            name="approval-confirm"
            checked={checked}
            onChange={() => {
              setChecked((prev: boolean) => !prev);
            }}
          />
          <label htmlFor="approval-confirm" className="-mt-0.5">
            <FormattedMessage
              id="approve_quotation_confirm"
              defaultMessage="Confermo di voler approvare il preventivo e sono consapevole del fatto che questa azione non può essere annullata."
            />
          </label>
        </div>
        <div className="w-full">
          <Button
            full
            onClick={onConfirm}
            disabled={!checked || loading}
            submitting={loading}
          >
            <FormattedMessage id="confirm"/>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
